/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

import loginPageStyle from "assets/jss/material-kit-pro-react/views/loginPageStyle.js";

import image from "assets/img/bg7.jpg";
import { ErrorMessage } from "components/Common/toastify";

import get from "../../lib/requests";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/Common/loading";
import { setUser } from "redux/ducks/userSlice";

const useStyles = makeStyles(loginPageStyle);

export default function LoginQRCodePage() {
	const classes = useStyles();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [qrCodeResponse, setQRCodeResponse] = useState(null);
	const userDetails = useSelector((state) => state.user);
	const dispatch = useDispatch();

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		if (userDetails) {
			redirectLogin(userDetails);
		} else {
			navigate("/login");
		}
		getQRCode();
	}, []);

	const redirectLogin = (response) => {
		if (response.callnext == "resetpassword") {
			navigate("/reset-password");
			return;
		} else if (response.callnext == "login/qrcode") {
			navigate("/login-qr-code");
			return;
		} else if (
			response.callnext == "login/mfa" ||
			response.callnext == "login/pin"
		) {
			navigate("/login-mfa");
			return;
		} else {
			if (userDetails?.csp) {
				// navigate("/csp-dashboard");
				window.location.href = "/csp-dashboard";
			} else {
				navigate("/dashboard");
			}
			return;
		}
	};

	const getQRCode = async () => {
		try {
			setLoading(true);
			await get("/api/login/qrcode", true)
				.then((res) => {
					if (res.data.success) {
						console.log("QR Code", res.data);
						setQRCodeResponse(res.data.records);
						const callnext = res.data.records.callnext;
						dispatch(setUser({ callnext }));
					} else {
						ErrorMessage("QR Code", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("QR Code", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("QR Code", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const closeOnClick = () => {
		navigate("/login-mfa");
	};

	return (
		<div>
			<Header
				absolute
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
			/>
			<div
				className={classes.pageHeader}
				style={{
					backgroundImage: "url(" + image + ")",
					backgroundSize: "cover",
					backgroundPosition: "top center",
				}}>
				<Loading width={20} height={20} className="text-center" />

				<div className={classes.container}>
					<GridContainer justify="center">
						<GridItem xs={12} sm={12} md={3}>
							<Card>
								<form
									id="myForm"
									className={loading ? classNames("opacity-40", classes.form) : ""}>
									<CardHeader color="info" signup className={classes.cardHeader}>
										<h4 className={classes.cartLabel}>Scan the QR Code to MFA</h4>
									</CardHeader>
									<CardBody signup>
										{qrCodeResponse && (
											<img src={qrCodeResponse?.qrimage} alt="QR Code" />
										)}
									</CardBody>
									<div className={classes.textCenter}>
										<Button simple color="info" size="lg" onClick={closeOnClick}>
											Next
										</Button>
									</div>
								</form>
							</Card>
						</GridItem>
					</GridContainer>
				</div>
			</div>
		</div>
	);
}
